import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { KiBefundAnzeige } from '../../../models/ki.model';
import { KiMarkComponent } from '../ki-mark/ki-mark.component';

/** Befund des Qualitätschecks als Kasten am Schritt bzw. unter der Ergebnis-Leiste (page-ki.jsx:400-437). */
@Component({
  selector: 'app-ki-befund-inline',
  imports: [KiMarkComponent, MatIconModule, TranslatePipe],
  templateUrl: './ki-befund-inline.component.html',
  styleUrl: './ki-befund-inline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiBefundInlineComponent {
  readonly befund = input.required<KiBefundAnzeige>();
  /** Heutiger Wert des Felds, auf das der Vorschlag zielt. */
  readonly aktuell = input<string | null>('');
  readonly readOnly = input(false);
  readonly uebernehmen = output<void>();
  readonly lassen = output<void>();

  /** Nur mit Feld und Vorschlag gibt es Diff und „Übernehmen“; sonst bleibt „Erledigt“. */
  protected readonly mitDiff = computed(() => !!this.befund().feld && !!this.befund().vorschlag);
}
